<script>
	import Router from 'svelte-spa-router'
	import Home from './routes/Home.svelte'
	import Settings from './routes/Settings.svelte'
	import Instructions from './routes/Instructions.svelte'
	import News from './routes/News.svelte'
	import EatAndDrink from './routes/EatAndDrink.svelte'
	import Partners from './routes/Partners.svelte'
	import Map from './routes/Map.svelte'
	import Article from './routes/Article.svelte'
	import MainConcerts from './routes/MainConcerts.svelte'
	import OtherEvents from './routes/OtherEvents.svelte'
	import Artist from './routes/Artist.svelte'
	import NotFound from './routes/NotFound.svelte'

	import { 
		current_lang, 
		news_api_storage, 
		news_cats_api_storage,
		artists_api_storage,
		venues_api_storage,
		translations,
	} from './stores.js';

	const routes = {
		'/': Home,
		'/settings/': Settings,
		'/instructions/': Instructions,
		'/eat-and-drink/': EatAndDrink,
		'/partners/': Partners,
		'/map/': Map,

		'/news/:cat?': News,
		'/article/:id': Article,

		'/main-concerts/:date?/:viewmode?': MainConcerts,
		'/other-events/:date?': OtherEvents,
		'/artist/:id': Artist,

		// Catch-all
		'*': NotFound,
	}

	//init lang
	let lang_value;
    current_lang.subscribe(value => {
        lang_value = value;
    });
	function set_current_lang(lang) {
        current_lang.set(lang);
		lang_value = lang;
    }

	//init news related apis
	let news_api_value = null;
    news_api_storage.subscribe(value => {
        news_api_value = value;
    });

	import {REST_getNewsByLang, REST_getArtists} from './wp-api/api.js';

	async function getNewsApi() {
		const news_fi = await REST_getNewsByLang("fi");
		const news_en = await REST_getNewsByLang("en");
		let news = {
			"fi": news_fi,
			"en": news_en
		};
		
		news_api_storage.set(news);
	}

	let news_cats_api_value = null;
    news_cats_api_storage.subscribe(value => {
        news_cats_api_value = value;
    });

	//init artists related apis
	let artists_api_value = null;
    artists_api_storage.subscribe(value => {
        artists_api_value = value;
    });

	async function getArtistsApi() {
		const artists = await REST_getArtists();
		artists_api_storage.set(artists);
	}
	let venues_api_value = null;
    venues_api_storage.subscribe(value => {
        venues_api_value = value;
    });

	async function getVenuesApi() {
		const venues_fi = [
			{
                id: 11, 
                name: "Päälava"
            },
            {
                id: 12, 
                name: "OP-lava"
            },
            {
                id: 13, 
                name: "Lokkilava"
            },
            {
                id: 215,
                name: 'Elämyslava <svg class="elamyslavaHeart" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126.87 128.14" height="0.8em"><path d="m0,34.82c.1-7.73,1.64-15.8,7.11-21.77,5.47-5.97,15.78-9.03,23.59-5.21,7.36,3.6,10.08,11.55,11.65,18.74,2.77,12.63,4.16,25.45,4.15,38.25,9.14-14.88,18.31-29.81,29.65-43.47,7.49-9.02,16.66-17.88,29.07-20.71,2.69-.61,5.55-.92,8.28-.33,7.19,1.56,10.95,8.57,12.3,14.91,5.44,25.44-11.01,49.94-29.33,69.78-11.81,12.78-24.65,25.01-38.61,36.03-10.56,8.33-17.11,11.04-24.7-1.34C17.72,94.48-.36,63.67,0,34.82"/></svg> OP'
            },
            {
                id: 16, 
                name: "Cafe Pori Jazz"
            },
            {
                id: 17, 
                name: "Poriljonki"
            },
            {
                id:18, 
                name: "Kehräämö"
            },
            {
                id: 15, 
                name: "Kirjurin kesäravintola"
            },
            {
                id: 14, 
                name: "Puistolava"
            },
            {
                id: 192,
                name: "Rattis"
            },
            {
                id: 190,
                name: "Amarillo"
            },
            {
                id: 191,
                name: "Kesäkävelykatu"
            },
            {
                id: 193,
                name: "Puuvilla"
            },
            {
                id: 186,
                name: "Satakielilava"
            },
            {
                id: 187,
                name: "KulttuuriKulma"
            },
            {
                id: 188,
                name: "Beer Hunter’s"
            },
            {
                id: 189,
                name: "Café Anton"
            },
        ];
		const venues_en = [
			{
                id: 11, 
                name: "Main stage"
            },
            {
                id: 12, 
                name: "OP-stage"
            },
            {
                id: 13, 
                name: "Lokki-stage"
            },
            {
                id: 215,
                name: 'Elämyslava <svg class="elamyslavaHeart" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126.87 128.14" height="0.8em"><path d="m0,34.82c.1-7.73,1.64-15.8,7.11-21.77,5.47-5.97,15.78-9.03,23.59-5.21,7.36,3.6,10.08,11.55,11.65,18.74,2.77,12.63,4.16,25.45,4.15,38.25,9.14-14.88,18.31-29.81,29.65-43.47,7.49-9.02,16.66-17.88,29.07-20.71,2.69-.61,5.55-.92,8.28-.33,7.19,1.56,10.95,8.57,12.3,14.91,5.44,25.44-11.01,49.94-29.33,69.78-11.81,12.78-24.65,25.01-38.61,36.03-10.56,8.33-17.11,11.04-24.7-1.34C17.72,94.48-.36,63.67,0,34.82"/></svg> OP'
            },
            {
                id: 16, 
                name: "Cafe Pori Jazz"
            },
            {
                id: 17, 
                name: "Poriljonki"
            },
            {
                id:18, 
                name: "Kehräämö"
            },
            {
                id: 15, 
                name: "Kirjurin kesäravintola"
            },
            {
                id: 14, 
                name: "Puistolava"
            },
            {
                id: 192,
                name: "Rattis"
            },
            {
                id: 190,
                name: "Amarillo"
            },
            {
                id: 191,
                name: "Kesäkävelykatu"
            },
            {
                id: 193,
                name: "Puuvilla"
            },
            {
                id: 186,
                name: "Satakielilava"
            },
            {
                id: 187,
                name: "KulttuuriKulma"
            },
            {
                id: 188,
                name: "Beer Hunter’s"
            },
            {
                id: 189,
                name: "Café Anton"
            },
        ];

		const venues = {
			"fi": venues_fi,
			"en": venues_en
		}

		venues_api_storage.set(venues);
	}

	import { onMount } from 'svelte';

	onMount(async () => {
		if(lang_value != "FI" && lang_value != "EN"){
        	set_current_lang("FI");
    	}

		if(news_api_value == null){
			getNewsApi();
		}

		if(artists_api_value == null){
			getArtistsApi();
		}

		if(venues_api_value == null){
			getVenuesApi();
		}
	});
</script>
<main>
	<Router {routes} />
	<div id="turn-phone-info">
		<div class="info-container">
			<img src="img/icons/turn-up-solid-white.svg" alt="phone icon"/>
			{$translations["ROTATE_DEVICE"][$current_lang]}
		</div>
	</div>
</main>

<style>
	#turn-phone-info{
		position: fixed;
		height: 100%;
		width: 100%;
		z-index: 4;
		background: var(--dark-color);
	}
	.info-container{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-family: 'futura-pt', Arial;
		font-weight: 500;
		text-decoration: none;
	}
	.info-container img{
		width: 30px;
		height: auto;
		margin-bottom: 15px;
	}

	#turn-phone-info{
		display: none;
	}

	@media screen and (orientation: landscape) and (max-height: 520px) {
		#turn-phone-info{
			display: block;
		}
	}
</style>